import { render, staticRenderFns } from "./DossierAutoSaleRowSettingEdit.vue?vue&type=template&id=0c6c8c5d&scoped=true&"
import script from "./DossierAutoSaleRowSettingEdit.vue?vue&type=script&lang=ts&"
export * from "./DossierAutoSaleRowSettingEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DossierAutoSaleRowSettingEdit.vue?vue&type=style&index=0&id=0c6c8c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c8c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6c8c5d')) {
      api.createRecord('0c6c8c5d', component.options)
    } else {
      api.reload('0c6c8c5d', component.options)
    }
    module.hot.accept("./DossierAutoSaleRowSettingEdit.vue?vue&type=template&id=0c6c8c5d&scoped=true&", function () {
      api.rerender('0c6c8c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierAutoSaleRowSettingEdit.vue"
export default component.exports